<section class="cx-dropdown-item__container">
  <ul>
    <li *ngFor="let value of values" (click)="selectItem(value)">
        {{value.descripcion|titlecase}}
    </li>
  </ul>
</section>
